import VueRouter from 'vue-router'

import App from './App.vue'
import NewVisit from './components/NewVisit.vue'
import Login from './components/Login.vue'
import Registration from './components/Registration.vue'
import PasswordRecovery from './components/PasswordRecovery.vue'
import FreeTermsList from './components/FreeTermsList.vue'
import FreeTermConfirmation from './components/FreeTermConfirmation.vue'
import ConfirmationResponse from './components/ConfirmationResponse.vue'

// IMPORTANT NOTE: When props is set to true, the $route.params will be set as the component props.
export default new VueRouter({
    base: '/secure/patients_plugin',
    mode: 'history',
    routes: [{
        path: '/',
        component: App,
        children: [
            {
                path: '',
                name: 'index', component: NewVisit
            },
            {
                path: '/login',
                name: 'login',
                component: Login
            },
            {
                path: '/registration',
                name: 'registration',
                component: Registration
            },
            {
                path: '/password-recovery',
                name: 'password-recovery',
                component: PasswordRecovery
            },
            {
                path: '/free-terms-list',
                name: 'free-terms-list',
                component: FreeTermsList
            },
            {
                path: '/free-term-confirmation',
                name: 'free-term-confirmation',
                component: FreeTermConfirmation,
                props: true
            },
            {
                path: '/confirmation-response/:inactiveUser',
                name: 'confirmation-response',
                component: ConfirmationResponse,
                props: true
            },
        ],
    }],
    scrollBehavior() {
      return {x: 0, y: 0}
    },
});



// WEBPACK FOOTER //
// ./src/router.js